import { 
  SET_USER_DATA, 
  SET_LOADING, 
  SET_ERROR,
  CLEAR_USER_DATA
} from '../reducers/userReducer';
import config from '../../config';
import { setToken, removeToken } from '../../utils/auth';

// Action to set user data after OTP verification
export const setUserData = (userData) => ({
  type: SET_USER_DATA,
  payload: userData
});

// Action to set loading state
export const setLoading = (isLoading) => ({
  type: SET_LOADING,
  payload: isLoading
});

// Action to set error
export const setError = (error) => ({
  type: SET_ERROR,
  payload: error
});

// Action to clear user data (logout)
export const clearUserData = () => {
  removeToken();
  return {
    type: CLEAR_USER_DATA
  };
};

// Thunk action to verify OTP and save user data
export const verifyOTPAndSaveData = (mobile, otp, courseType) => {
  return async (dispatch) => {
    dispatch(setLoading(true));
    
    try {
      let data;
      if (config.environment === 'development') {
        data = await config.services.verifyOtp(mobile, otp, courseType);
      } else {
        const formData = new URLSearchParams();
        formData.append('action', 'verifyotp');
        formData.append('mobile', mobile);
        formData.append('otp', otp);
        formData.append('courseType', courseType);

        const response = await fetch(`${config.baseUrl}${config.api.verifyOtp}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: formData
        });

        data = await response.json();
      }

      if (data.status) {
        // Store the JWT token if provided in the response
        if (data.data && data.data.token) {
          setToken(data.data.token);
        }
        
        // Save user data to Redux store
        dispatch(setUserData({
          mobile,
          courseType,
          testDone: data.data?.testDone || false,
          testUrl: data.data?.testUrl || null,
          percentage: data.data?.percentage || 0,
          ...data.data
        }));
        
        return data;
      } else {
        dispatch(setError(data.message || 'Invalid OTP'));
        return null;
      }
    } catch (err) {
      dispatch(setError('Failed to verify OTP. Please try again.'));
      console.error('Error verifying OTP:', err);
      return null;
    } finally {
      dispatch(setLoading(false));
    }
  };
}; 